import { render, staticRenderFns } from "./line-notify.vue?vue&type=template&id=5c310776&scoped=true&"
import script from "./line-notify.vue?vue&type=script&lang=js&"
export * from "./line-notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c310776",
  null
  
)

export default component.exports